import Dropdown from "../../../../../components/UI/DropDown/DropDown";
import { useBotStateContext } from "../../../contexts/BotContext";
import editorAction from "../../../actions/editorAction";
import VariableEdition from "../VariablesManager/VariableEdition/VariableEdition";
import NiceModal from "@ebay/nice-modal-react";
import AutoComplete from "/src/components/UI/AutoComplete/AutoComplete";
import "./VariablesDropdown.css"
import { useState,useEffect } from "react";
// This component if an implement of Dropdown component with current variable's of the bot
// It's working like a normal dropdown with some cool functionnality
// 1. you can select a choice to open a modal an directy create a variable
// 2. the choices are in Uppercase like this [TEST] (rest of the old version for not losing the old's users) 
// 3. When you select a choice it return and object not just a simple string

function VariableDropdown ({ variable, register, setValue, width, className, name, createVariableDisable, resetVariableDisable, noChangeOnSelect }) {


    const [mainVariable, setMainVariable] = useState(variable == null ? "" :variable);
    const { addVariable } = editorAction()

    const { variables } = useBotStateContext();
    const openModalCreationVariable = async () => {
        const data = await NiceModal.show('editor-popup', { Component : VariableEdition });
        addVariable(data)
    }

    const choices = variables.map( variable => { return { text : "[" + variable.name.toUpperCase() + "]", value : variable.name} })
    if(!createVariableDisable) {
        choices.push({ value : 'create_variable', text : 'Create a Variable'})
    }

    if(!resetVariableDisable) {
        choices.push({ value : 'reset_variable', text : 'Choose a Variable'})
    }
    
    const setValueVariable = (name, value, dropdown) => {
        if(value == 'create_variable') {
            dropdown.func(dropdown.state)
            return openModalCreationVariable()
        }
        if(value == 'reset_variable') {
            setValue(name, null);
            return;
        }
        const variable = variables.filter(variable => variable.name == value).pop();
        setValue(name, variable)
    }

    const props = {
        choices, width : "calc(100%)", setValue : setValueVariable
    }

    if(!resetVariableDisable) {
        props.defaultChoice = 'reset_variable';
        delete props.placeholder;
    }

    if(variable == undefined) {
        props.placeholder = "Choose a variable";
    }
    else {
        props.defaultChoice = variable.name;
    }

    if(width != undefined) {
        props.width = width
    }

    if(className != undefined) {
        props.className = className
    }

    if(name != undefined) {
        props.name = name
    }

    if(noChangeOnSelect != undefined) {
        props.noChangeOnSelect = noChangeOnSelect
    }

    const isVariableFind = () => {
        if (variable == null) return;
        let val = variable.name;    
        val = val.replace(/\[/g, '').replace(/\]/g, '');
        return variables.filter(variable => variable.name == val.toLowerCase()).length > 0;
    };
    useEffect(() => {
        setMainVariable(variable);
    }, [])

    return <AutoComplete {...register} {...props} className={"input variables_dropdown_editor " + (isVariableFind() ? "variables_found_editor_dropdown" : "") } 
    value={mainVariable ? "[" + mainVariable?.name.toUpperCase() + "]" : ""} 
    items={variables} getNameFromItem={(item)=>"[" + item.name.toUpperCase() +"]"} getItemValue={(name,item)=> setValueVariable(name,item.name)}
    ></AutoComplete>

}

VariableDropdown.defaultProps = {
    register : {},
    createVariableDisable : false,
    resetVariableDisable : false,
    setValue : () => {}
}

export default VariableDropdown;